export const createAsyncActionStatuses = type => ({
  CNTRL: `CNTRL_${type}`,
  PREFIX: `RX_${type}`,
  DONE: `RX_${type}_DONE`,
  PENDING:  `RX_${type}_PENDING`
});